import { render, staticRenderFns } from "./vendorView.vue?vue&type=template&id=600c73bc&"
import script from "./vendorView.vue?vue&type=script&lang=js&"
export * from "./vendorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports